// extracted by mini-css-extract-plugin
export var centerText = "_69-8";
export var container = "_69-0";
export var doughnutContainer = "_69-7";
export var legend = "_69-a";
export var legendItemColorDisplay = "_69-b";
export var legendItemLabel = "_69-d";
export var legendItemValue = "_69-c";
export var lg = "_69-5";
export var maxWidth = "_69-9";
export var md = "_69-4";
export var responsive = "_69-6";
export var sm = "_69-3";
export var xs = "_69-2";
export var xxs = "_69-1";